import { getAddIntegrationFormDrawerContent } from '@modules/integrationsV2/utils/getAddIntegrationFormDrawerContent';
import { Box, Drawer } from '@mui/material';
import {
  IntegrationChannelViewFragment,
  IntegrationType,
} from 'generated/graphql';

interface AddIntegrationFormDrawerProps {
  integrationChannel: IntegrationChannelViewFragment | undefined;
  integrationType: IntegrationType | undefined;
  isOpen: boolean;
  onDrawerClose: () => void;
}

export const AddIntegrationFormDrawer = ({
  integrationChannel,
  integrationType,
  isOpen,
  onDrawerClose,
}: AddIntegrationFormDrawerProps) => {
  return (
    <Drawer open={isOpen} anchor="right" onClose={onDrawerClose}>
      <Box width="45vw" minWidth="700px" height="100vh" overflow="auto">
        {integrationChannel &&
          integrationType &&
          getAddIntegrationFormDrawerContent({
            integrationChannel,
            integrationType,
            onDrawerClose,
          })}
      </Box>
    </Drawer>
  );
};
